import React from 'react';

import { isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';

import type { RecordedItem } from '@modules/advancement/pendingItems/types';
import { determineAuditData } from '@modules/advancement/pendingItems/utils';
import { DateView, S } from '@shared/components';
import { advancementStatusDate } from '@shared/utils';

import { RequirementAdvancementType } from '../PendingItemsTable/PendingRequirementsColumns';
import styles from './PendingItemsList.less';

export const renderDefaultRows = () => (item: RecordedItem) => {
  const { date, requirementName } = item;
  const div = document.createElement('p');
  div.innerHTML = requirementName;
  const clean = div.textContent || div.innerText || '';
  const auditData = determineAuditData(item);

  return [
    {
      rowId: 'requirementName',
      label: <RequirementAdvancementType row={item} />,
      content: (
        <div>
          <p className={styles.requirementName}>{clean}</p>
          {!isEmpty(auditData) && (
            <S size="6" className={styles.audit} italic>
              <FormattedMessage
                id="advancement.PendingItems.audit"
                values={{
                  status: auditData.status,
                  name: auditData.name ?? '',
                  date: auditData.date,
                }}
              />
            </S>
          )}
        </div>
      ),
      className: styles.requirementNameContainer,
    },
    {
      rowId: 'completionDate',
      label: (
        <S size="4" bold>
          <FormattedMessage id="advancement.PendingItems.column.itemDate" />
        </S>
      ),
      content: (
        <S size="4">
          <DateView value={date || advancementStatusDate.getCompleted(item)} />
        </S>
      ),
    },
  ];
};
